module.exports = __webpack_public_path__ + "static/media/brankarsky_trenink.fd06f494.jpg";